var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 7.875C8.60938 7.875 9.125 8.39062 9.125 9V11.2266L11.4219 5.57812L5.77344 7.875H8ZM6.875 9H3.875C3.5 9 3.19531 8.76562 3.125 8.41406C3.05469 8.0625 3.24219 7.71094 3.57031 7.57031L11.8203 4.19531C12.1016 4.07812 12.4297 4.14844 12.6406 4.35938C12.8516 4.57031 12.9219 4.89844 12.8047 5.17969L9.42969 13.4297C9.28906 13.7578 8.9375 13.9453 8.58594 13.875C8.23438 13.8047 8 13.5 8 13.125V10.125V9H6.875Z",
    fill: "#525252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationArrow);
export default __webpack_public_path__ + "static/media/location-arrow.09d0abd0158b6dcbba04fc7044068da9.svg";
export { ForwardRef as ReactComponent };